import classNames from 'classnames';
import * as React from 'react';

import patientLeft from '../assets/hero-v3/Chest Male.svg';
import patientRight from '../assets/hero-v3/Specific patient report.svg';
import arrowRight from '../assets/hero-v3/Vector 1995.jpg';
import hero1 from '../assets/hero-v3/img-1.svg';
import heroMob1 from '../assets/hero/heroMob1.svg';
import { Label, Label1 } from '../consts';
import '../hero.scss';
import CtaButton from './CtaButton';

function Hero1() {
  return (
    <>
      <div className='bg-base-100'>
        <div className='container mx-auto'>
          <div className='flex md:p-0 md:text-left text-center'>
            <div className='relative p-4 flex z-0 flex-col md:flex-row max-w-none w-full justify-start items-start pt-0 md:pt-5 md:pb-40 lg:pb-52'>
              {/* DESKTOP HERO IMAGE */}
              <div className='z-0 hidden md:flex absolute h-full overflow-visible w-full justify-end left-0 right-0'>
                <div className='relative right-0 p-0 h-full'>
                  <img src={hero1} className='h-full' />
                </div>
              </div>
              <div className='z-10 flex-1 flex-col items-start justify-start'>
                {/* MOBILE HERO IMAGE */}
                <div className='flex flex-col flex-1 w-full gap-10'>
                  <div className='flex md:hidden flex-center flex-1'>
                    <img src={heroMob1} className='md:mr-7 w-full' />
                  </div>
                  <h1
                    className={classNames(
                      'md:hidden block w-full max-w-none',
                      'copyfont font-semibold',
                      'text-left',
                      'text-[1.65rem] leading-[2.27rem]',
                    )}
                  >
                    {/* MOBILE */}
                    Efficiency for Your <br />
                    Emergency Department and Urgent Care
                  </h1>
                  <h1
                    className={classNames(
                      'hidden md:block',
                      'copyfont font-semibold',
                      'text-[2.85rem] leading-[3.37rem]',
                    )}
                  >
                    {/* DESKTOP */}
                    Efficiency for Your <br />
                    Emergency Department and Urgent Care
                  </h1>
                </div>
                <div className='h-4'></div>
                <div className='text-hero-content text-left md:pr-32'>{Label.label2}</div>
                <div className='h-8'></div>
                <div>
                  <CtaButton />
                </div>
              </div>
              <div className='justify-end hidden md:flex flex-1 w-full md:w-[50%] h-full'></div>
            </div>
          </div>
        </div>
      </div>

      <div className='h-10'></div>
      <div className='h-0 md:h-10'></div>

      <div className='container mx-auto flex-1 flex'>
        <div className='hero2-1-v2 flex-1 md:p-0 md:text-left flex-center'>
          <div className='hero-content gap-4 flex-col'>
            <div className='title text-center'>{Label.label1}</div>
            <div className='content text-center'>
              {
                "Crafted in Patients' Language, Translated into Reports That Mirror Familiar Clinical Notes"
              }
            </div>
          </div>
        </div>
      </div>

      <div className='flex flex-1 md:px-32 md:pb-16'>
        <div className='flex-1 flex'>
          <div className='hero2-2'>
            <div className='flex-1 flex-center pt-5 md:pt-16'>
              <div className='px-5 md:px-10'>
                <img src={patientLeft} className='w-full' />
              </div>
            </div>

            <div className='h-full flex-center'>
              <div className='px-6 md:px-10 py-6 md:py-0'>
                <img src={arrowRight} className='w-full rotate-90 md:rotate-0' />
              </div>
            </div>

            <div className='flex-1 flex-center pt-5 md:pt-16'>
              <div className='px-5 md:px-10'>
                <img src={patientRight} className='w-full' />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='flex flex-1 bg-light2 flex-center py-20'>
        <div className='hero1 flex-col gap-20 px-10'>
          <h3 className='title mobileCenter text-lg'>{Label.label3}</h3>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14 md:gap-y-10'>
            {Label1.map((item, idx) => {
              return (
                <div key={item.title} className='flex-center'>
                  <div key={item.title} className='flex-col gap-4 text-center max-w-[250px]'>
                    <div className='relative h-0 w-0'>
                      <div className='absolute top-6 left-9 overflow-visible'>
                        <div className='w-10 h-10 text-white bg-primary rounded-full flex-center font-bold'>
                          {idx + 1}
                        </div>
                      </div>
                    </div>
                    <div className='flex flex-center'>
                      <img src={item.img} className='w-52 h-52' />
                    </div>
                    <div className='flex-col gap-1'>
                      <div className='font-semibold text-lg'>{item.title}</div>
                      <div className='opacity-70'>{item.subTitle}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(Hero1);
